import { Link } from "react-router-dom";

// Help & support — ported from Luan's #app-help section. Static content + links into existing
// surfaces (Messages for support, Ask Aria). No new backend.
const Chevron = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="6 9 12 15 18 9" /></svg>
);

const FAQS: { q: string; a: React.ReactNode }[] = [
  { q: "How do I schedule a visit?", a: <>Click <strong>Book a visit</strong> in the sidebar, choose what&rsquo;s going on, pick your doctor, and select a time. Most visits start in under 15 minutes.</> },
  { q: "How do I cancel or reschedule?", a: <>Open the <strong>Visits</strong> page, choose the visit you&rsquo;d like to change, and use the actions at the bottom. You can reschedule free of charge up to 1 hour before your visit.</> },
  { q: "How do prescriptions work?", a: <>Your doctor sends prescriptions directly to your preferred pharmacy at the end of your visit. Premium members can use our mail-order pharmacy with free 2-day shipping.</> },
  { q: "Can I switch doctors?", a: <>Anytime. There are no referrals required. Just pick a different doctor on your next booking.</> },
];

export function Help() {
  return (
    <>
      <div className="app-page-head">
        <h1>Help &amp; <em>support.</em></h1>
        <p>Find answers fast — or get in touch with a real human.</p>
      </div>

      <div className="help-hero">
        <h3>Need help with <em>something specific?</em></h3>
        <p>Our care team is available 24/7 — most replies arrive in under 5 minutes.</p>
        <div className="help-actions">
          <Link className="btn btn-primary" to="/messages">
            Message support
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><path d="M21 11.5a8.4 8.4 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.4 8.4 0 0 1-3.8-.9L3 21l1.9-5.7a8.4 8.4 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.4 8.4 0 0 1 3.8-.9h.5a8.5 8.5 0 0 1 8 8v.5z" /></svg>
          </Link>
          <Link className="btn btn-ghost" to="/concierge">Ask Aria</Link>
        </div>
      </div>

      <div className="settings-card">
        <h3>Frequently asked</h3>
        <div style={{ marginTop: 12 }}>
          {FAQS.map((f) => (
            <details className="faq-item" key={f.q}>
              <summary>{f.q}<Chevron /></summary>
              <div className="faq-answer">{f.a}</div>
            </details>
          ))}
        </div>
      </div>
    </>
  );
}
